import {
  Button,
  Divider,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  TextField,
} from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import {  useNavigate } from "react-router";

export default function PaymentDetails({
  setsubDetails,
  subDetails,
  handleSubscribe,
  total,
  setTotalPrice,
  PaymentMethods,
}) {
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false);
  const [isValid, setValid] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // Extract an array of prices using map
    const loginCheck = localStorage.getItem("user")
    if (loginCheck) {
      if (subDetails.menu && subDetails.menu.length > 0) {
        const pricesArray = subDetails.menu.map(
          (item) => item.dish.price * item.quantity
        );
        let totalPricePerDay = pricesArray.reduce(
          (accumulator, currentPrice) => accumulator + currentPrice,
          0
        );
        totalPricePerDay = totalPricePerDay * subDetails.noOfDays;
        setTotalPrice(totalPricePerDay);

        if (
          subDetails.paymentId &&
          subDetails.endDate &&
          subDetails.startDate &&
          subDetails.deliveryTime &&
          subDetails.deliveryAddress &&
          subDetails.subType &&
          subDetails.noOfDays > 0
        ) {
          setValid(true);
        } else {
          setValid(false);
        }
      } else {
        setTotalPrice(0);
        setValid(false);
      }
    } else {
      navigate("/login")
    }
  }, [subDetails]);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          // width: "526px",
          width: "100%",
          height: "626px",
          border: "1px solid #E1E1E6",
          borderRadius: "4px",
          padding: "24px",
          pr: "24px",
        }}
      >
        <Box>
          <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>
            Payment Details
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: "20px", fontWeight: "600", pt: "16px" }}>
            Summary
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            pt: "16px",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "400", color: "#9EA3AE" }}
            >
              Price
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "400", color: "#1A1824" }}
            >
              ${total}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            pt: "16px",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "400", color: "#9EA3AE" }}
            >
              Delivery fee
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "400", color: "#1A1824" }}
            >
              Free
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            pt: "16px",
            pb: "16px",
          }}
        >
          <Box>
            <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
              Total payment
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
              ${total}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Divider />
        </Box>

        <Box sx={{ marginTop: "16px" }}>
          <InputLabel
            className="inputlabel"
            sx={{
              fontSize: "20px",
              color: "#1a1824",
              fontWeight: "500",
            }}
          >
            Promotion Code
          </InputLabel>
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              mt: "8px",
            }}
          >
            <TextField
              className="inputfield"
              fullWidth
              value={subDetails.promotionCode}
              onChange={(e) =>
                setsubDetails({ ...subDetails, promotionCode: e.target.value })
              }
              label="Enter promotion code"
              id="promotion code"
            />
          </Box>
        </Box>

        <Box sx={{ marginTop: "16px" }}>
          <Typography
            style={{
              fontSize: "14px",
              color: "#1A1824",
              fontFamily: "Outfit",
              fontWeight: "600",
            }}
          >
            Payment Method
          </Typography>
          <FormControl
            sx={{
              mt: 1,
              mb: 2,
              width: "100%",
              marginRight: "12px",
            }}
            size="small"
          >
            <Select
              labelId="code-label"
              id="Payment Id"
              name="paymentId"
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              value={subDetails.paymentId}
              onChange={(e) =>
                setsubDetails({ ...subDetails, paymentId: e.target.value })
              }
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
              }}
              sx={{
                background: "#F6F6F6",
              }}
            >
              {PaymentMethods?.data?.map((option) => (
                <MenuItem
                  key={option.last4}
                  value={option._id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  **** **** **** {option.last4}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box>
          <Divider />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            mt: "16px",
          }}
        >
          <Box>
            <Typography sx={{ fontSize: "18px", fontWeight: "400" }}>
              Total
            </Typography>
            <Typography
              sx={{
                fontSize: { lg: "40px", md: "30px", sm: "20px", xs: "20px" },
                fontWeight: "600",
                pt: "8px",
              }}
            >
              $ {total}
            </Typography>
          </Box>

          <Box>
            <Button
              // disabled={!isValid}
              sx={{
                borderRadius: "6px",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "capitalize",
                width: {
                  xl: "267px",
                  lg: "267px",
                  md: "267px",
                  sm: "150px",
                  xs: "150px",
                },
                height: "48px",
                alignItems: "center",
                justifyContent: "center",
                mt: "37px",
              }}
              variant="contained"
              onClick={() => handleSubscribe()}
            >
              Place Order
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
